import * as types from '../mutation-types'
import Business from '../../controllers/Business'
import Location from '../../controllers/Location'
import Roles from '../../controllers/Roles'

const appList = [
	{id: 9, app_id: 'resources_link', route: 'resources', fa: 'fa-file-image-o', title: 'Resources'},
	{id: 11, app_id: 'uno_games_link', route: 'uno_games', fa: 'fa-trophy', title: 'UNOgames'},
	{id: 12, app_id: 'ecomm_link', route: '', fa: 'fa-shopping-cart', title: 'Ecomm'}
]

const state = {
	userAccounts: [],
	activeAccount: {},
	businessLocationApps: [],
	roleApps: [],
	v3Token: ''
}

export const getters = {
	selectedAccountId: state => state.activeAccount.account_id,
	userAccounts: state => state.userAccounts,
	userAccountsLength: state => state.userAccounts.length,
	firstUserAccount: state => state.userAccounts.length ? state.userAccounts[0] : {},
	activeAccount: state => state.activeAccount,
	unoappAccount: state => state.activeAccount.account_type === 'unoapp',
	businessAccount: state => state.activeAccount.account_type === 'business',
	locationAccount: state => state.activeAccount.account_type === 'location',
	activeBusinessId: state => state.activeAccount.business_id,
	activeBusinessName: state => state.activeAccount.business_name,
	activeLocationId: state => state.activeAccount.location_id,
	activeLocationName: state => state.activeAccount.location_name,
	accessibleApps: state => {
		let localRoleApps = [...state.roleApps].filter(app => app.access_level !== 'none').map(app => app.id)
		let localApps = [...state.businessLocationApps].filter(app => localRoleApps.indexOf(app.id) !== -1)

		return localApps
	},
	v3Token: state => state.v3Token
}

export const actions = {
	setActiveUserAccounts ({ commit }, accountList) {
		commit(types.SET_ACTIVE_USER_ACCOUNTS, {
			accountList
		})
	},
	setActiveAccount ({ commit }, account) {
		/* eslint-disable no-undef */
		if (localStorage.getItem('activeBusiness')) {
			let business = JSON.parse(localStorage.getItem('activeBusiness'))
			if (business.business_id) {
				account.business_id = business.business_id
				account.business_name = business.business_name
			}
		}

		commit(types.SET_ACTIVE_ACCOUNT, {
			account
		})

		if (account.account_type === 'location') {
			Roles.getLocationRole(account.role_id).then(response => {
				let localAppList = []
				response.payload.app_permissions.forEach(app => {
					appList.forEach(appListApp => {
						if (appListApp.id === app.app_id) {
							appListApp.access_level = app.access_level
							localAppList.push(appListApp)
						}
					})
				})

				commit(types.SET_ROLE_APP_LIST, {
					apps: localAppList
				})
			}).catch(e => {
				console.log(e)
			})
		} else if (account.account_type === 'business') {
			Roles.getRole(account.role_id).then(response => {
				let localAppList = []
				response.payload.app_permissions.forEach(app => {
					appList.forEach(appListApp => {
						if (appListApp.id === app.app_id) {
							appListApp.access_level = app.access_level
							localAppList.push(appListApp)
						}
					})
				})

				commit(types.SET_ROLE_APP_LIST, {
					apps: localAppList
				})
			}).catch(e => {
				console.log(e)
			})
		} else if (account.account_type === 'unoapp') {
			commit(types.SET_ROLE_APP_LIST, {
				apps: appList
			})
		}
	},
	setActiveBusinessId ({ commit }, businessId) {
		if (!state.activeAccount.business_id || state.activeAccount.business_id !== businessId) {
			commit(types.CLEAR_ACTIVE_LOCATION)
		}

		commit(types.SET_ACTIVE_BUSINESS_ID, {
			businessId
		})

		Business.getBusinessDetails(businessId).then(response => {
			let localAppList = []
			response.payload.apps.forEach(app => {
				appList.forEach(appListApp => {
					if (appListApp.id === app.app_id) {
						localAppList.push(appListApp)
					}
				})
			})

			commit(types.SET_APP_LIST, {
				localAppList
			})
		}).catch(e => {
			console.log(e)
		})
	},
	setActiveBusinessName ({ commit }, businessName) {
		commit(types.SET_ACTIVE_BUSINESS_NAME, {
			businessName
		})
	},
	clearActiveBusiness ({ commit }) {
		commit(types.CLEAR_ACTIVE_BUSINESS)
	},
	setActiveLocationId ({ commit }, locationId) {
		commit(types.SET_ACTIVE_LOCATION_ID, {
			locationId
		})

		Location.getLocationDetails(locationId).then(response => {
			let localAppList = []
			response.payload.apps.forEach(app => {
				appList.forEach(appListApp => {
					if (appListApp.id === app.app_id) {
						localAppList.push(appListApp)
					}
				})
			})

			commit(types.SET_APP_LIST, {
				localAppList
			})
		}).catch(e => {
			console.log(e)
		})
	},
	setActiveLocationName ({ commit }, locationName) {
		commit(types.SET_ACTIVE_LOCATION_NAME, {
			locationName
		})
	},
	clearActiveLocation ({ commit }) {
		commit(types.CLEAR_ACTIVE_LOCATION)
	},
	setV3Token ({ commit }, token) {
		commit(types.SET_V3_TOKEN,
			token
		)
	}
}

export const mutations = {
	[types.SET_ACTIVE_USER_ACCOUNTS] (state, payload) {
		state.userAccounts = payload.accountList
	},
	[types.SET_ACTIVE_ACCOUNT] (state, payload) {
		if (!payload.account.location_id) {
			payload.account.location_id = 0
			payload.account.location_name = ''
		}
		state.activeAccount = payload.account
	},
	[types.SET_ACTIVE_BUSINESS_ID] (state, payload) {
		state.activeAccount.business_id = payload.businessId
	},
	[types.SET_ACTIVE_BUSINESS_NAME] (state, payload) {
		state.activeAccount.business_name = payload.businessName
	},
	[types.CLEAR_ACTIVE_BUSINESS] (state, payload) {
		state.activeAccount.business_name = ''
		state.activeAccount.business_id = 0
		/* eslint-disable no-undef */
		localStorage.removeItem('activeBusiness')
	},
	[types.SET_ACTIVE_LOCATION_ID] (state, payload) {
		state.activeAccount.location_id = payload.locationId
	},
	[types.SET_ACTIVE_LOCATION_NAME] (state, payload) {
		state.activeAccount.location_name = payload.locationName
	},
	[types.CLEAR_ACTIVE_LOCATION] (state, payload) {
		state.activeAccount.location_name = ''
		state.activeAccount.location_id = 0
		/* eslint-disable no-undef */
		localStorage.removeItem('activeLocation')
	},
	[types.CLEAR_ACCOUNT_VARIABLES] (state, payload) {
		state.userAccounts = []
		state.activeAccount = {}
	},
	[types.SET_APP_LIST] (state, payload) {
		state.businessLocationApps = payload.localAppList
	},
	[types.SET_ROLE_APP_LIST] (state, payload) {
		state.roleApps = payload.apps
	},
	[types.SET_V3_TOKEN] (state, token) {
		state.v3Token = token
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js